module.exports = __webpack_public_path__ + "officialStatic/img/xfjjDetailList1.a340382.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/xfjjDetailList1.png
// module id = RkRA
// module chunks = 0